import React, { useEffect, useState, useRef } from "react";
import { useCurrentUserHook } from "../../Authentication/useUserHook";
import DynamicForm from "../../FormBuilder/DynamicForm";
import FormContainer from "../../FormBuilder/FormContainer";
import JourneyProfileService from "./JourneyProfileService";

function JourneyProfileForm(props) {
  const {currentUser} = useCurrentUserHook();

  const {match, history, editPermission, toggleModal, onSubmit} = props;
  const params = match.params;
  const path = match.path;
  const formId = params.form_id;

  let {current:scope} = useRef({
    formMode:null,
    form:{},
    data:{},
    formFn:{}
  })

  const [isFormRendered, setFormRendered] = useState(false);
  const [post, setPost] = useState({});

  const get = async () => {
    const {status, data} = await JourneyProfileService.get(params.id);
    if(status === 200){
      scope.form = data;
      scope.data = scope.form.data;
      setFormRendered(true);
    }
  }

  useEffect(() => {
    scope.formFn = {"form_type": "journey_profile", "editPermission": editPermission}
    scope.formMode = "create-form-submissions"
    if (params.id) {
      get()
      scope.formMode = "edit-form-submissions"
    } else if (!isFormRendered) {
      setFormRendered(true)
    }
  }, [])

  const create = async (form) => {
    form.form_id = formId;
    form.journey_type = params.journey_type;
    form.organization_id = currentUser.current_organization_id;
    form.org_member_id = currentUser.current_member.id;
    form.form_dsl_id = params.form_dsl_id;
    
    const {status, data} = await JourneyProfileService.create(form);
    if(status === 201){
      onSubmit(data);
      toggleModal();
    }
  }

  const update = async (form) => {
    const {status, data} = await JourneyProfileService.update(form);
    if(status === 204){
      onSubmit(form);
      toggleModal();
    }
  }

  if (isFormRendered) {
    return (
      <FormContainer post={post} isPopupMode={props.isPopupMode}>
        <DynamicForm formMode={scope.formMode}
          formId={formId}
          form={scope.form}
          data={scope.data}
          formFn={scope.formFn}
          onCreate={create}
          onUpdate={update}
          post={post}
          onCancel={toggleModal}
          setPost={setPost}
          isPopupMode={props.isPopupMode}/>
      </FormContainer>
    )
  } 

  return null;
  
}

export default JourneyProfileForm;